<mat-card *ngIf="dataSource.data?.length > 0">
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2>
      {{ dataSource.data[0].userDesc }}
    </h2>

    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button mat-icon-button id="showCard" fxLayoutAlign="end center" (click)="displayCard()" [disableRipple]="false">
        <mat-icon [class]="isTableHidden ? 'icon-ic_add_circle_outline' : 'icon-ic_remove_circle_outline'"></mat-icon>
      </button>
    </div>
  </div>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="invest-datail-table" mat-table [dataSource]="dataSource" *ngIf="!isTableHidden">
        <ng-container matColumnDef="seller">
          <th mat-header-cell *matHeaderCellDef class="first-row" translate>investDetail.sellerHeader</th>
          <td mat-cell *matCellDef="let element" class="first-row">{{ element.userDesc }}</td>
          <td mat-footer-cell *matFooterCellDef class="first-row" translate>investDetail.total</td>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.codeHeader</th>
          <td mat-cell *matCellDef="let element">{{ element.contractId }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.clientHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.holderName }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="prod">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.prodHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.finProd }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="dateForm">
          <th mat-header-cell *matHeaderCellDef class="fixed" translate>investDetail.dateFormHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left fixed">{{ element.autDate }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="investment">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.investmentHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ element.invest | transformNumber }}
          </td>
          <td mat-footer-cell *matFooterCellDef>{{ totals.totalInvest | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="tin">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.tinHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ element.tin | transformNumber }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="incentive">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.incentiveHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">
            {{ element.incentive | transformNumber }}
          </td>
          <td mat-footer-cell *matFooterCellDef>{{ totals.totalIncent | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="term">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.termHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.deadlines }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.typeHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.description }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.brandHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.brand }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="model">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.modelHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.model }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="prot">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.protHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.strSeg }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="rapp">
          <th mat-header-cell *matHeaderCellDef translate>investDetail.rappHeader</th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.rappel }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator
      hidePageSize
      [pageSize]="15"
      [pageIndex]="page"
      (page)="savePage($event)"
      *ngIf="!isTableHidden && dataSource.data?.length > 15"
      showFirstLastButtons
    ></mat-paginator>
  </mat-card-content>
</mat-card>
